import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'uk_UA',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '627297fb-e5b1-4319-b628-6fed864a292a',
  ''
);
